export default "__VITE_ASSET__85c4477f__"